import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// One-time cleanup of any legacy PWA/service-worker cache from older builds so
// stale customer app-shell or API responses can never be restored. Bump
// CLIENT_STATE_VERSION to force another purge on the next release.
const CLIENT_STATE_VERSION = "2026-09-04";
(async () => {
  try {
    if (localStorage.getItem("cd_state_version") === CLIENT_STATE_VERSION) return;
    if (navigator.serviceWorker && navigator.serviceWorker.getRegistrations) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
    if (window.caches && caches.keys) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
    localStorage.setItem("cd_state_version", CLIENT_STATE_VERSION);
  } catch (e) { /* best effort */ }
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
